module.exports = __webpack_public_path__ + "img/electronic_reserved.d4dcd23d.svg";